import * as React from 'react';
import { Circle, G, Path } from 'react-native-svg';

function Glasses() {
  return (
    <>
      <Circle cx={50.73} cy={84.96} r={13.81} fill="#e5f3f3" opacity={0.44} />
      <G fill="none" strokeLinecap="round" strokeLinejoin="round">
        <Path d="M38.35 80.2l6.07.09" stroke="#fff" />
        <Path d="M38.48 78.49l3.7.06" stroke="#fff" strokeWidth={0.86} />
        <Path
          d="M71.48 89.64a5.19 5.19 0 00-4.83-2.14c-3.86.49-4.33 5-6.87 7.27a13.81 13.81 0 114.55-10 13.68 13.68 0 01-1.57 6.18"
          stroke="#ddbf0c"
          strokeWidth={1.71}
        />
      </G>
      <Circle cx={86.09} cy={87.27} r={13.81} fill="#e5f3f3" opacity={0.44} />
      <G fill="none" strokeLinecap="round" strokeLinejoin="round">
        <Path d="M73.71 82.51l6.07.09" stroke="#fff" />
        <Path d="M73.84 80.81h3.7" stroke="#fff" strokeWidth={0.86} />
        <Circle cx={85.89} cy={86.83} r={13.81} stroke="#ddbf0c" strokeWidth={1.71} />
      </G>
    </>
  );
}

export default Glasses;
